var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C6.125 16.5 3.5 15 2.0625 12.5C0.625 10.0312 0.625 7 2.0625 4.5C3.5 2.03125 6.125 0.5 9 0.5C11.8438 0.5 14.4688 2.03125 15.9062 4.5C17.3438 7 17.3438 10.0312 15.9062 12.5C14.4688 15 11.8438 16.5 9 16.5ZM6.46875 5.96875C6.15625 6.28125 6.15625 6.75 6.46875 7.03125L7.9375 8.5L6.46875 9.96875C6.15625 10.2812 6.15625 10.75 6.46875 11.0312C6.75 11.3438 7.21875 11.3438 7.5 11.0312L8.96875 9.5625L10.4375 11.0312C10.75 11.3438 11.2188 11.3438 11.5 11.0312C11.8125 10.75 11.8125 10.2812 11.5 9.96875L10.0312 8.5L11.5 7.03125C11.8125 6.75 11.8125 6.28125 11.5 5.96875C11.2188 5.6875 10.75 5.6875 10.4375 5.96875L8.96875 7.4375L7.5 5.96875C7.21875 5.6875 6.75 5.6875 6.46875 5.96875Z",
    fill: "#F16A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/Close_X.13c21df6f4032978e58176dafe948946.svg";
export { ForwardRef as ReactComponent };